import { ApiHelper, IApiResponse } from "../../utils/api-helper";

const url = `${process.env.REACT_APP_API_ENDPOINT}/Identity`;

class PermissionService extends ApiHelper {
  constructor(_url: string) {
    super(_url);
  }

  public getPermission(): Promise<IApiResponse | void> {
    try {
      this.url = `${url}/PermissionGroups`;
      return super.get()
    } catch (e) {
      throw e;
    }
  }
}
const permissionAPI = new PermissionService(url);
export default permissionAPI;
